  import {
    Grid,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Accordion,
    AccordionSummary,
    AccordionDetails
  } from '@mui/material';
  import Iconify from 'src/components/iconify';

  const HoursTable = ({ overtime, standard, employee }) => {
    console.log("🚀 ~ HoursTable ~ standard:", standard)
    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    
    // Get rates from employee data if available
    const regularTimeRate = employee?.apiData?.time_sheet?.weekly_time_sheet?.[0]?.entries?.[0]?.trade_worker_title?.regular_time_rate || standard.payRate;
    const overTimeRate = employee?.apiData?.time_sheet?.weekly_time_sheet?.[0]?.entries?.[0]?.trade_worker_title?.over_time_rate || overtime.payRate;
    
    // Format employee name for the header
    const employeeName = employee?.name || '';

    return (
      <Grid item xs={12}>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}>
            <b>
              {employeeName}
            </b>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small" sx={{ bgcolor: "#f5f5f5" }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '18px', color: 'black' }}>Day</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '16px', color: 'black' }}>Standard Hours</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '16px', color: 'black' }}>Overtime Hours</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {days.map((day) => (
                    <TableRow key={day}>
                      <TableCell>{day.charAt(0).toUpperCase() + day.slice(1)}</TableCell>
                      <TableCell align="right">{standard[day] || 0}</TableCell>
                      <TableCell align="right">{overtime[day] || 0}</TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>Total Hours</TableCell>
                    <TableCell align="right">{standard.totalHours}</TableCell>
                    <TableCell align="right">{overtime.totalHours}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>Pay Rate</TableCell>
                    <TableCell align="right">${regularTimeRate}</TableCell>
                    <TableCell align="right">${overTimeRate}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>Total Earned</TableCell>
                    <TableCell align="right">${standard.totalEarned}</TableCell>
                    <TableCell align="right">${overtime.totalEarned}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </Grid>
    );
  };

  export default HoursTable;